import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing-style-four',
  templateUrl: './pricing-style-four.component.html',
  styleUrls: ['./pricing-style-four.component.scss']
})
export class PricingStyleFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
